import { useMemo } from "react";
import usePlans from "./usePlans";
import { makeTabTypeFromPlan } from "@/components/newcustomize/utils/makeProxyTabType";

export function useHasVerifiedProxyPlan() {
  const { data } = usePlans();

  return useMemo(() => {
    if (!data) return false;
    return data.results?.some(
      (plan) =>
        makeTabTypeFromPlan(plan) === "verified" && plan.status === "active"
    );
  }, [data]);
}
